import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import PeerPage from '../views/PeerPage.vue'
const routes = [
  {
    path: '/render',
    children: [
      {
        path: ':pageType/:id',
        component: HomePage,
        children: [
          // 子页面
          {
            path: ':subId',
            component: HomePage,
          }
        ]
      }
    ],
  },
  {
    path: '/backup/:backupid',
    children: [
      {
        path: ':pageType/:id',
        component: HomePage,
        children: [
          // 子页面
          {
            path: ':subId',
            component: HomePage,
          }
        ]
      }
    ],
  },
  {
    path: '/peerPage/:id',
    component: PeerPage,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
